import { render, staticRenderFns } from "./SendEgiftPanelGreetingIdeas.vue?vue&type=template&id=5cbb2f2f&scoped=true"
import script from "./SendEgiftPanelGreetingIdeas.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelGreetingIdeas.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelGreetingIdeas.vue?vue&type=style&index=0&id=5cbb2f2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb2f2f",
  null
  
)

export default component.exports